export default {
  Auth: {
    Cognito: {
      region: import.meta.env.VITE_COGNITO_USER_POOL_REGION,
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_APP_CLIENT_ID,
    },
  },
}
